module.exports = __webpack_public_path__ + "img/3-6-2.8427bd0e.png";